export default __webpack_public_path__ + "b6de3d8e06408d8627ffa7f065395298.png";